<template>
  <div>
    <h5 class="mb-3">ABHA Consent Management</h5>
    <b-card no-body>
      <b-table
        :items="consentList"
        :fields="fields"
        responsive
        striped
        small
        :head-variant="'dark'"
        thead-class="table-light"
        show-empty
        empty-text="No consent requests found"
      >
        <template #cell(consent_status)="{ item }">
          <b-badge
            :variant="
              item.consent_status === 'APPROVED'
                ? 'success'
                : item.consent_status === 'REJECTED'
                ? 'danger'
                : 'warning'
            "
          >
            {{ item.consent_status }}
          </b-badge>
        </template>
        <template #cell(actions)="{ item }">
          <b-button
            v-if="!item.consent_token"
            variant="primary"
            size="sm"
            @click="generateLink(item)"
          >
            Generate Link
          </b-button>
          <template v-if="item.consent_token && item.consent_status === 'PENDING'">
            <b-button
              variant="info"
              size="sm"
              class="ml-1"
              @click="sendNotification(item, 'SMS')"
            >
              Send SMS
            </b-button>
            <b-button
              variant="info"
              size="sm"
              class="ml-1"
              @click="sendNotification(item, 'EMAIL')"
            >
              Send Email
            </b-button>
          </template>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import recipientService from "../../assets/services/recipient.service";

export default {
  data() {
    return {
      consentList: [],
      fields: [
        { key: "first_name", label: "Patient Name" },
        { key: "phone_number_1", label: "Phone" },
        { key: "email_id", label: "Email" },
        { key: "consent_status", label: "Status" },
        { key: "created_on", label: "Created" },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  methods: {
    async loadList() {
      try {
        this.$loader.show();
        const { data } = await recipientService.getConsentList({});
        if (data.status && data.list) {
          this.consentList = data.list;
        }
        this.$loader.hide();
      } catch (error) {
        this.$loader.hide();
      }
    },
    async generateLink(item) {
      try {
        this.$loader.show();
        const { data } = await recipientService.generateConsentLink({
          recipient_registration_id: item.recipient_registration_id,
          phone_number: item.phone_number_1,
          email_id: item.email_id,
        });
        if (data.status) {
          this.$alert.show("Consent link generated", "success");
          this.loadList();
        } else {
          this.$alert.show(data.msg);
        }
        this.$loader.hide();
      } catch (error) {
        this.$loader.hide();
        this.$alert.show("Error generating link");
      }
    },
    async sendNotification(item, channel) {
      try {
        this.$loader.show();
        const { data } = await recipientService.sendConsentNotification({
          consent_token: item.consent_token,
          phone_number: item.phone_number_1,
          email_id: item.email_id,
          notification_channel: channel,
        });
        if (data.status) {
          this.$alert.show(data.msg, "success");
        } else {
          this.$alert.show(data.msg);
        }
        this.$loader.hide();
      } catch (error) {
        this.$loader.hide();
        this.$alert.show("Error sending notification");
      }
    },
  },
  mounted() {
    this.loadList();
  },
};
</script>
